import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Label from 'ui-library/bs/Label';
import TextArea from 'ui-library/bs/TextArea';
import {TextAreaChangeEvent} from 'util/Types';

export interface ReviewCommentProps {
  comment: string | undefined;
  onChange: (e: TextAreaChangeEvent) => void;
  labelClassName?: string;
  rowCount: number;
  disabled: boolean;
  showRedAsterisk: boolean;
  shouldAutoFocus?: boolean;
}

export const ReviewComment = React.forwardRef<HTMLTextAreaElement, ReviewCommentProps>(
  (
    {
      comment,
      onChange,
      labelClassName = '',
      rowCount,
      disabled,
      shouldAutoFocus = false,
      showRedAsterisk,
    }: ReviewCommentProps,
    ref
  ) => (
    <div>
      <Label className={labelClassName}>
        Comment{showRedAsterisk ? <span className={css(styles.red)}>*</span> : null}
      </Label>
      <TextArea
        autoFocus={shouldAutoFocus}
        placeholder="Leave a comment..."
        rows={rowCount}
        value={comment}
        onChange={onChange}
        disabled={disabled}
        {...getTestProps({component: 'ReviewComment', element: 'textArea'})}
      />
    </div>
  )
);

const styles = StyleSheet.create({
  red: {color: 'red'},
});
